export const parseCareCenterAddress = (address) => {
  const fields = [
    address?.street,
    address?.city,
    address?.zip,
    address?.state,
  ].filter((field) => !!field);

  return fields.length > 0 ? fields.join(', ') : 'Unknown address';
};
